import { render, staticRenderFns } from "./UiBaseModal.vue?vue&type=template&id=fdaa091a"
import script from "./UiBaseModal.vue?vue&type=script&lang=js"
export * from "./UiBaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports